<template>
  <div>
    <el-form ref="form" :rules="rules" :model="info" label-width="160px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名" prop="farmerName">
            <el-input placeholder="请输入" :disabled="InfoType === 'details'" v-model="info.farmerName" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别" prop="gender">
            <el-select style="width: 100%" placeholder="请选择" :disabled="InfoType === 'details'" v-model="info.gender">
              <el-option :value="1" label="男" />
              <el-option :value="2" label="女" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="民族" prop="national">
            <el-input placeholder="请输入" :disabled="InfoType === 'details'" v-model="info.national" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证" prop="idCardNo">
            <el-input placeholder="请输入" :disabled="InfoType === 'details'" v-model="info.idCardNo" @blur="idCardBlur" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="出生年月" prop="birthday">
            <el-date-picker v-model="info.birthday" type="date" :disabled="InfoType === 'details'" style="width: 100%"
              value-format="yyyy-MM-dd" placeholder="请选择日期" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产队" prop="teamNo">
            <el-select :disabled="InfoType === 'details'" v-model="info.teamNo" filterable placeholder="请选择"
              style="width: 100%">
              <el-option v-for="item in teamDataList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员性质" prop="peopleNature">
            <el-select style="width: 100%" placeholder="请选择" :disabled="InfoType === 'details'"
              v-model="info.peopleNature">
              <el-option v-for="item in peopleNatureList" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员类别" prop="peopleType">
            <el-select style="width: 100%" placeholder="请选择" :disabled="InfoType === 'details'" v-model="info.peopleType">
              <el-option v-for="item in peopleTypeList" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否仅享受收益分配" prop="onlyShareDisFlag">
            <el-radio-group v-model="info.onlyShareDisFlag" placeholder="请选择" :disabled="InfoType === 'details'"
              style="width: 100%">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="现居住地" prop="livePlace">
            <el-input placeholder="请输入" maxlength="100" :disabled="InfoType === 'details'" v-model="info.livePlace" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="户籍地址" prop="registrationAddress">
            <el-input placeholder="请输入" maxlength="100" :disabled="InfoType === 'details'"
              v-model="info.registrationAddress" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="phone">
            <el-input placeholder="请输入" :disabled="InfoType === 'details'" v-model="info.phone" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行卡" prop="bankCardNo">
            <el-input placeholder="请输入" :disabled="InfoType === 'details'" v-model="info.bankCardNo" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行" prop="bank">
            <el-input placeholder="请输入" :disabled="InfoType === 'details'" v-model="info.bank" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否为户主" prop="houseHolderFlag">
            <el-select style="width: 100%" placeholder="请选择" :disabled="InfoType === 'details'"
              v-model="info.houseHolderFlag" @change="typeChange">
              <el-option :value="1" label="是" />
              <el-option :value="0" label="否" />
            </el-select>
          </el-form-item>
        </el-col>
        <template v-if="info.houseHolderFlag == 0">
          <el-col :span="12">
            <el-form-item label="户主" prop="houseHolder">
              <!-- <el-select v-model="info.houseHolder" filterable placeholder="请选择" :disabled="InfoType === 'details'"
                style="width: 100%" @change="changeHouseHolder">
                <el-option v-for="item in memberList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select> -->
              <el-select v-model="info.houseHolder" filterable remote reserve-keyword placeholder="请输入户主名称搜索"
                :disabled="InfoType === 'details'" :remote-method="remoteMethod"  @change="changeHouseHolder">
                <el-option v-for="(item, index) in memberList"
                  :key="index" :value="item.id" :label="`${item.name || '暂无'}-${item.cardNo || '暂无'}`">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户主身份证" prop="houseHolderIdCardNo">
              <el-input placeholder="请输入" disabled v-model="info.houseHolderIdCardNo" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="与户主关系" prop="houseHolderRelation">
              <el-input placeholder="请输入" :disabled="InfoType === 'details'" v-model="info.houseHolderRelation" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户主联系电话" prop="houseHolderPhone">
              <el-input placeholder="请输入" disabled v-model="info.houseHolderPhone" />
            </el-form-item>
          </el-col>
        </template>
        <el-col :span="12">
          <el-form-item label="承包地确权总面积(亩)" prop="landConfirmTotalArea">
            <el-input-number style="width: 100%" :controls="false" placeholder="请输入" :disabled="InfoType === 'details'"
              v-model="info.landConfirmTotalArea" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="宅基地土地使用权面积(m²)" prop="landHomesteadArea">
            <el-input-number style="width: 100%" :controls="false" placeholder="请输入" :disabled="InfoType === 'details'"
              v-model="info.landHomesteadArea" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合计份额" prop="totalAge">
            <el-input disabled v-model="info.totalAge" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员编号">
            <el-input  v-model="info.farmerSortNo" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="dialog-footer" style="display:flex;justify-content:center" v-if="InfoType == 'edit'">
      <el-button type="primary" @click="submit">修 改</el-button>
      <el-button type="primary" @click="closeInfo">关 闭</el-button>
    </el-row>
  </div>
</template>

<script>
/**
 * 详情/编辑 空缺
 */
import { getBirth, getSex } from '@/assets/scripts/validate'
import { euFarmerInfoAdd, euFarmerInfoUpdate, teamQuery, euFarmerInfoQuery } from '@/api/community.js'
// euFarmerInfoExport
export default {
  props: {
    InfoType: {
      type: String,
      default: 'new'
    },
    infoDetails: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      peopleNatureList: [
        {
          value: '原始'
        },
        {
          value: '继承'
        },
      ],
      peopleTypeList: [
        {
          value: '正常'
        },
        {
          value: '失联'
        },
        {
          value: '赠与'
        },
        {
          value: '已故'
        },
        {
          value: '冻结'
        },
        {
          value: '五保户'
        },
        {
          value: '冻结1'
        },
        {
          value: '合并'
        },
        {
          value: '赎回'
        }
      ],
      info: {
        farmerName: '',
        gender: '',
        national: '',
        idCardNo: '',
        birthday: '',
        teamNo: '',
        peopleNature: '',
        peopleType: '',
        onlyShareDisFlag: 0,
        livePlace: '',
        registrationAddress: '',
        phone: '',
        bankCardNo: '',
        bank: '',
        houseHolderFlag: 0,
        houseHolder: '',
        houseHolderIdCardNo: '',
        houseHolderRelation: '',
        houseHolderPhone: '',
        landConfirmTotalArea: '',
        landHomesteadArea: '',
        totalAge: 0,
        farmerSortNo: ''
      },
      teamDataList: [],
      memberList: [],
      rules: {
        farmerName: [{ required: true, message: '请填写', trigger: 'blur' }],
        onlyShareDisFlag: [{ required: true, message: '请选择', trigger: 'blur' }],
        peopleType: [{ required: true, message: '请选择', trigger: 'change' }],
        gender: [{ required: true, message: '请选择', trigger: 'change' }],
        national: [{ required: true, message: '请填写', trigger: 'blur' }],
        idCardNo: [{ required: true, message: '请填写', trigger: 'blur' }],
        birthday: [{ required: true, message: '请选择', trigger: 'change' }],
        teamNo: [{ required: true, message: '请填写', trigger: 'change' }],
        peopleNature: [{ required: true, message: '请填写', trigger: 'blur' }],
        livePlace: [{ required: true, message: '请填写', trigger: 'blur' }],
        registrationAddress: [{ required: true, message: '请填写', trigger: 'blur' }],
        phone: [{ required: true, message: '请填写', trigger: 'blur' }],
        bankCardNo: [{ required: true, message: '请填写', trigger: 'blur' }],
        bank: [{ required: true, message: '请填写', trigger: 'blur' }],
        houseHolderFlag: [{ required: true, message: '请选择', trigger: 'change' }],
        houseHolder: [{ required: true, message: '请选择', trigger: 'change' }],
        houseHolderIdCardNo: [{ required: true, message: '请填写', trigger: 'blur' }],
        houseHolderRelation: [{ required: true, message: '请填写', trigger: 'blur' }],
        // houseHolderPhone: [{ required: true, message: '请填写', trigger: 'blur' }],
        landConfirmTotalArea: [{ required: true, message: '请填写', trigger: 'blur' }],
        landHomesteadArea: [{ required: true, message: '请填写', trigger: 'blur' }]
      }
    }
  },
  methods: {
    changeHouseHolder(value) {
      let data = this.memberList.find((item) => item.id === value)
      this.info = {
        ...this.info,
        houseHolderIdCardNo: data?.cardNo,
        houseHolderPhone: data?.phone
      }
    },
    typeChange() {
      this.info = {
        ...this.info,
        houseHolder: '',
        houseHolderIdCardNo: '',
        houseHolderRelation: '',
        houseHolderPhone: '',
      }
    },
    // 获取生产队
    getTeamData() {
      teamQuery({
        pageSize: 999,
        pageNum: 1,
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.teamDataList = (result.records || []).map((item) => {
          return {
            name: item.name,
            id: `${item.teamNo}`
          }
        })
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.getMemberList(query)
      } else {
        this.options = [];
      }
    },
    // 获取人员
    getMemberList(farmerName) {
      euFarmerInfoQuery({
        pageNum: 1,
        pageSize: 100,
        name: farmerName,
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.memberList = (result.records || []).map((item) => {
            return {
              name: item.farmerName,
              id: item.farmerNo,
              cardNo: item.idCardNo,
              phone: item.phone
            }
          })
        }
      })
    },
    closeInfo() {
      this.$emit('closeInfo')
    },
    // 提交
    submit() {
      this.$refs.form.validate((valid) => {
        delete this.info.houseHolderName
        if (valid) {
          if (this.InfoType === 'edit') {
            // console.log(this.infoDetails, 'this.infoDetails');
            // if (this.info.houseHolder === '') { // 是户主
            //   this.info.houseHolder = this.infoDetails.farmerNo
            // }
            let teamData = this.teamDataList.find(item => item.id === this.info.teamNo)
            euFarmerInfoUpdate({
              ...this.info,
              teamName: teamData.name
            }).then(res => {
              if (res.code === 0) {
                this.$emit('closeInfo', true)
              }
            })
          } else {
            let teamData = this.teamDataList.find(item => item.id === this.info.teamNo)
            euFarmerInfoAdd({
              ...this.info,
              teamName: teamData.name
            }).then(res => {
              if (res.code === 0) {
                this.$emit('closeInfo', true)
              }
            })
          }
        }
      })
    },
    idCardBlur() {
      let reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (reg.test(this.info.idCardNo)) {
        this.info.gender = getSex(this.info.idCardNo)
        this.info.birthday = getBirth(this.info.idCardNo)
      }
    }
  },
  watch: {
    infoDetails: {
      handler() {
        if (this.infoDetails) {
          this.info = { ...this.infoDetails }
          setTimeout(() => {
            this.getMemberList(this.infoDetails.houseHolderName)
          }, 500)
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getTeamData()
    // this.getMemberList()
  }
}
</script>